import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
import { money } from "@/components/reports/reportUtils";

const BUCKET_ORDER = ["por_vencer", "1-30", "31-60", "61-90", "90+"];
const BUCKET_LABELS = { por_vencer: "Por vencer", "1-30": "1-30 días", "31-60": "31-60 días", "61-90": "61-90 días", "90+": "+90 días" };

export function ReporteCxC({ data }) {
  const items = data?.items || [];
  const sub = data?.subtotales_por_tramo || {};
  return (
    <div>
      <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-5" data-testid="reporte-cxc-subtotales">
        {BUCKET_ORDER.map((b) => (
          <Card key={b} data-testid={`reporte-cxc-bucket-${b}`}>
            <CardContent className="p-3">
              <p className="text-xs text-muted-foreground">{BUCKET_LABELS[b]}</p>
              <p className="mt-1 font-mono text-sm font-bold">{money(sub[b]?.total_usd)}</p>
              <p className="mt-0.5 text-[10px] text-muted-foreground">
                Confirmada {money(sub[b]?.confirmada_usd)} · Estimada {money(sub[b]?.estimada_usd)}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
      {data?.truncado && (
        <p className="mb-2 text-xs font-medium text-amber-600" data-testid="reporte-cxc-truncado">
          Hay más resultados de los que se muestran acá — exportá a Excel para verlos todos.
        </p>
      )}
      <Table data-testid="reporte-cxc-table">
        <TableHeader>
          <TableRow>
            <TableHead>Load</TableHead><TableHead>Cliente</TableHead><TableHead>Referencia</TableHead>
            <TableHead className="text-right">Monto USD</TableHead><TableHead>Vencimiento</TableHead>
            <TableHead className="text-right">Días</TableHead><TableHead>Antigüedad</TableHead><TableHead>Tipo de fecha</TableHead>
            {/* P34 (2026-09-23): pedido al cerrar P20 — ver desde acá qué ya se facturó en QuickBooks. */}
            <TableHead>Facturado en QBO</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((r, i) => (
            <TableRow key={i} data-testid={`reporte-cxc-row-${r.numero_load}`}>
              <TableCell className="font-mono text-xs">{r.numero_load}</TableCell>
              <TableCell>{r.client_nombre}</TableCell>
              <TableCell className="text-xs">{r.referencia_cliente}</TableCell>
              <TableCell className="text-right">{money(r.monto_cobro_usd)}</TableCell>
              <TableCell className="text-xs">{r.fecha_vencimiento || "—"}</TableCell>
              <TableCell className="text-right">{r.dias_vencimiento}</TableCell>
              <TableCell className="text-xs">{r.antiguedad}</TableCell>
              <TableCell className="text-xs">
                <span className={r.fecha_delivery_estimada ? "text-amber-600" : "text-emerald-700"}>{r.tipo_fecha}</span>
              </TableCell>
              <TableCell className="text-xs" data-testid={`reporte-cxc-qbo-${r.numero_load}`}>
                {r.facturado_qbo ? (
                  <span className="font-mono text-emerald-700">
                    {r.qbo_doc_number}{r.qbo_modo === "simulada" ? " (simulada)" : ""}
                  </span>
                ) : (
                  <span className="text-muted-foreground">No</span>
                )}
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow><TableCell colSpan={9} className="text-center text-sm text-muted-foreground py-8">Sin resultados para los filtros aplicados.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
